//frontend/src/components/ProtectedRoute.js

import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import axios from "axios";


const API_URL = process.env.REACT_APP_BACKEND_URL;

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [checkingAuth, setCheckingAuth] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const verifyToken = async () => {
      const userString = localStorage.getItem("user");
      if (!userString) {
        setIsAuthenticated(false);
        setIsAdmin(false);
        setCheckingAuth(false);
        return;
      }

      const user = JSON.parse(userString);
      try {
        const response = await axios.post(`${API_URL}/auth/verify`, {
          token: user.token,
        });

        if (response.status === 200 && response.data.valid) {
          setIsAuthenticated(user.access); // Check `access` from localStorage
          setIsAdmin(user.is_admin); // Use the admin flag
        } else {
          localStorage.removeItem("user");
          setIsAuthenticated(false);
          setIsAdmin(false);
        }
      } catch (error) {
        localStorage.removeItem("user");
        setIsAuthenticated(false);
        setIsAdmin(false);
      } finally {
        setCheckingAuth(false);
      }
    };

    verifyToken();
  }, []);

  if (checkingAuth) {
    return <div>Loading...</div>; // Show loading indicator while checking auth
  }

  // Admin-only access for `/admin` route
  if (location.pathname === "/admin" && !isAdmin) {
    return <Navigate to="/login" />;
  }

  // Restrict non-admin users without `access: true`
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
